import $ from 'jquery';
import { delivery } from "../queries";

(async function () {
    if ($('.page-personal').length === 0) {
        return;
    }
    const response = await delivery(['delivery_personal']);
    $('.page-personal-delivery__items').html(response.component).removeClass('page-personal-delivery__items--loading');
    let error = false;
    $('h2').map(function (){
        if ($(this).text() === 'Адреса доставки не найдены'){
            error= true
        }
    })
    if (error){
        $('.page-personal-delivery-form').fadeIn()
    }
    $('.ui-scroll').each(function () {
        $(this).trigger('init');
    });
})();
(async function () {
    $('.ui-scroll').each(function () {
        $(this).trigger('init');
    });
})();



